export const TAG_COLORS = {
    Користувачі: '#6AA4BF',
    "Об'єкти": '#9F7AEA',
    Звіти: '#65C294',
    Модеми: '#d69e2e',
    Лічильники: '#ED8936',
    Файли: '#ED64A6',
    Модулі: '#667EEA',
    Моніторинг: '#3182CE',
    Аномалії: '#E53E3E',
};

export const getTagInfo = (typeCode) => {
    if (!typeCode) return {name: 'Інше', color: '#cbd5e1'};
    const strCode = String(typeCode);

    if (strCode === 'device_data_anomaly') {
        return {name: 'Аномалії', color: TAG_COLORS['Аномалії']};
    }

    if (strCode === 'device_data_monitoring') {
        return {name: 'Моніторинг', color: TAG_COLORS['Моніторинг']};
    }

    if (strCode.startsWith('user_')) {
        return {name: 'Користувачі', color: TAG_COLORS['Користувачі']};
    }

    if (strCode.match(/organization_|building_|room_/)) {
        return {name: "Об'єкти", color: TAG_COLORS["Об'єкти"]};
    }

    if (strCode.startsWith('report_')) {
        return {name: 'Звіти', color: TAG_COLORS['Звіти']};
    }

    if (strCode.startsWith('uspd_')) {
        return {name: 'Модеми', color: TAG_COLORS['Модеми']};
    }

    if (strCode.startsWith('device_')) {
        return {name: 'Лічильники', color: TAG_COLORS['Лічильники']};
    }

    if (strCode.startsWith('file_') || strCode.startsWith('datafile_')) {
        return {name: 'Файли', color: TAG_COLORS['Файли']};
    }

    if (strCode.startsWith('module_')) {
        return {name: 'Модулі', color: TAG_COLORS['Модулі']};
    }

    if (strCode.includes('error') || strCode.includes('invalid') || strCode.includes('fail')) {
        return {name: 'Помилки', color: TAG_COLORS['Помилки']};
    }

    return {name: 'Сповіщення', color: '#cbd5e1'};
};

export const NOTIFICATION_TYPES_TRANSLATION = {
    user_created: 'Створення користувача',
    user_registered: 'Реєстрація користувача',
    user_activated: 'Активація користувача',
    user_status_changed: 'Зміна статусу користувача',
    user_deleted: 'Видалення користувача',
    user_building_assigned: 'Закріплення будинку за користувачем',
    user_organization_assigned: 'Закріплення організації за користувачем',

    report_created: 'Створення звіту',
    report_deleted: 'Видалення звіту',

    organization_created: 'Створення організації',
    organization_deleted: 'Видалення організації',
    building_created: 'Створення будинку',
    building_deleted: 'Видалення будинку',
    room_created: 'Створення приміщення',
    room_deleted: 'Видалення приміщення',

    uspd_created: 'Створення модема (USPD)',
    uspd_deleted: 'Видалення модема (USPD)',
    uspd_blocked: 'Блокування модема (USPD)',
    uspd_unblocked: 'Розблокування модема (USPD)',
    uspd_processing_error: 'Помилка обробки даних модема',

    device_created: 'Створення лічильника',
    device_deleted: 'Видалення лічильника',
    device_found_new: 'Знайдено новий лічильник',
    device_assigned_room: 'Лічильник закріплено за приміщенням',
    device_data_anomaly: 'Аномалії даних лічильників',
    device_data_monitoring: 'Моніторинг даних лічильників',

    file_empty: 'Знайдено пустий файл',
    file_invalid: 'Не вдалося обробити файл',
    file_device_errors: 'Знайдено помилки в лічильниках',
    file_uspd_missing: 'Немає файлу від модему',

    module_data_collector: 'Робота модуля Data Collector',
    module_avz: 'Робота модуля АВЗ',
    module_kte: 'Робота модуля КТЕ',
    module_kvk: 'Робота модуля КВК',
    module_lvk: 'Робота модуля ЛВК',
};

export const getNotificationName = (typeCode) => {
    return NOTIFICATION_TYPES_TRANSLATION[typeCode] || typeCode;
};

export const CATEGORIES_TRANSLATION = {
    Users: 'Користувачі',
    Reports: 'Звіти',
    Objects: "Об'єкти",
    USPD: 'Модеми',
    Devices: 'Лічильники',
    'Data Files': 'Файли',
    Modules: 'Модулі',
};
